import React, { useEffect, useState } from "react";
import { ReactComponent as Recommended } from "../../../../../assets/svg/recommended.svg";
import { ReactComponent as ToBePublished } from "../../../../../assets/svg/toBePublished.svg";
import { ReactComponent as CREnabled } from "../../../../../assets/svg/gsai-cr-enabled.svg";
import { ReactComponent as WarningIcon } from "../../../../../assets/svg/warning-icon-gsai.svg";

import { Dropable } from "../../dnd";
import useDataList from "./DataList";
import EmptyToBePublished from "./EmptyToBePublished";
import "./index.scss";
import Selection from "./Selection";
import CreativeReplacement from "./CreativeReplacement";
import {
  StyledContent,
  StyledErrorMsgContainer,
  StyledToolTipContainer,
} from "./styled";
import { usePreview } from "../CreateAdVariants/hooks";
import { useDispatch } from "react-redux";

export const DescAdsContainer: React.FunctionComponent<{}> = ({}) => {
  const {
    onDragStart,
    onDrop,
    handlePinning,
    handleDelete,
    handleInputChange,
    dnd,
  } = useDataList("descriptions");

  const { descriptions } = usePreview();
  const dispatch = useDispatch();

  useEffect(() => {
    let val: boolean = false;
    dnd?.descriptions?.toBePublished?.forEach((e: any, index: number) => {
      const idx = dnd?.descriptions?.toBePublished?.findIndex(
        (k: any, i: number) => index != i && e?.value == k?.value
      );
      if (idx >= 0) {
        val = true;
      }
    });
    dispatch({
      type: "UPDATE_GSAI_STORE",
      payload: {
        dnd: {
          ...dnd,
          descriptions: { ...dnd.descriptions, toBePublishedError: val },
        },
      },
    });
  }, [dnd?.descriptions?.toBePublished]);
  useEffect(() => {
    let val: boolean = false;
    dnd?.descriptions?.replacements?.forEach((e: any, index: number) => {
      const idx = dnd?.descriptions?.replacements?.findIndex(
        (k: any, i: number) => index != i && e?.value == k?.value
      );
      if (idx >= 0) {
        val = true;
      }
    });
    dispatch({
      type: "UPDATE_GSAI_STORE",
      payload: {
        dnd: {
          ...dnd,
          descriptions: { ...dnd.descriptions, creativeReplacementError: val },
        },
      },
    });
  }, [dnd?.descriptions?.replacements]);

  React.useEffect(() => {
    const crConst = {
      creative_replacement: false,
      description: [
        {
          selected: false,
          label: "Best Performance",
          performance: "BEST",
          interval: "",
        },
        {
          selected: false,
          label: "Good Performance",
          performance: "GOOD",
          interval: "",
        },
        {
          selected: false,
          label: "Low Performance",
          performance: "LOW",
          interval: "",
        },
      ],
    };
  }, []);

  const selectionProps = {
    onDragStart,
    handlePinning,
    handleDelete,
    handleInputChange,
    type: "descriptions" as "headlines" | "descriptions",
    limit: 90,
  };

  return (
    <div className="create-variant-ads-container">
      <div className="variant-info">
        <div className="recommended-variant ads-container-header">
          <Recommended className="variant-header-svg" />
          <span className="container-header">Recommended</span>
        </div>
        <Dropable
          handleDrop={onDrop}
          target="recommended"
          className="ad-container-body"
          isDroppable={true}
        >
          <div className="create-ad-variant">
            <Selection
              data={dnd.descriptions.recommended}
              more={dnd.descriptions.more}
              source="recommended"
              {...selectionProps}
            />
          </div>
        </Dropable>
      </div>
      <div className="variant-info">
        <div className="ads-container-header">
          <div className="text-center flex-1">
            <ToBePublished className="variant-header-svg" />
            <span className="container-header">To Be Published</span>
            <span className="container-header-count">
              {" "}
              {dnd.descriptions.toBePublished?.length} / 4
            </span>
          </div>
          {descriptions.length < 2 && (
            <StyledToolTipContainer className="warning-for-publish">
              <WarningIcon
                style={{ width: 26, height: 26, cursor: "pointer" }}
              />
              <StyledContent
                top={"29px"}
                right={"0px"}
                className="content"
                style={{ zIndex: 100000 }}
              >
                <div className="" style={{ zIndex: 100000 }}>
                  Not enough assets. Add unpinned assets or make sure that you
                  pin assets to every position.
                </div>
              </StyledContent>
            </StyledToolTipContainer>
          )}
        </div>
        <div className="to-be-published">
          <Dropable
            handleDrop={onDrop}
            target="toBePublished"
            className="ad-container-body tbp"
            isDroppable={dnd.descriptions.toBePublished.length < 4}
          >
            {dnd.descriptions.toBePublished?.length ? (
              <div className="create-ad-variant">
                <Selection
                  data={dnd.descriptions.toBePublished}
                  source="toBePublished"
                  {...selectionProps}
                />
                {dnd?.descriptions?.toBePublishedError && (
                  <StyledErrorMsgContainer>
                    Descriptions are identical. Enter a different description.
                  </StyledErrorMsgContainer>
                )}
              </div>
            ) : (
              <EmptyToBePublished />
            )}
          </Dropable>
          <CreativeReplacement type="descriptions">
            <Dropable
              handleDrop={onDrop}
              target="replacements"
              className="ad-container-body tbp"
              isDroppable={true}
            >
              {dnd.descriptions.replacements?.length ? (
                <div className="create-ad-variant">
                  <Selection
                    data={dnd.descriptions.replacements}
                    source="replacements"
                    {...selectionProps}
                  />
                  {dnd?.descriptions?.creativeReplacementError && (
                    <StyledErrorMsgContainer>
                      Descriptions are identical. Enter a different description.
                    </StyledErrorMsgContainer>
                  )}
                </div>
              ) : (
                <div className="cr-content">
                  <CREnabled />
                </div>
              )}
            </Dropable>
          </CreativeReplacement>
        </div>
      </div>
    </div>
  );
};
